import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { userReducer, setUser, setDropboxLocations, setPaymentType, setUserPrices, setUserPrimers, setWpsExcludeCorp, isLoggedIn, logout } from "./slices/usersSlice";
import { userAdminReducer, isAdminLoggedIn, setUserAdmin, logoutAdmin } from "./slices/adminSlice";
import {
  initializeFreeTrialData,
  setFreeTrialSampleAmount,
  setFreeTrialServiceOption,
  setFreeTrialServicePriority,
  editFreeTrialRow,
  increaseFreeTrialConcentration,
  decreaseFreeTrialConcentration,
  editFreeTrialComments,
  freeTrialReducer,
  clearFreeTrialSelect,
  resetFreeTrialState,
  resetFreeTrialPage,
  freeTrialNextStep,
  setFreeTrialOrderNumber,
  freeTrialPrevStep,
} from "./slices/freeTrialSlice";

import {
	initializeFreeTrialDataWPS,
	setFreeTrialSampleAmountWPS,
	editFreeTrialRowWPS,
	increaseFreeTrialConcentrationWPS,
	decreaseFreeTrialConcentrationWPS,
	editFreeTrialCommentsWPS,
	freeTrialReducerWPS,
	clearFreeTrialSelectWPS,
	resetFreeTrialStateWPS,
	resetFreeTrialPageWPS,
	freeTrialNextStepWPS,
	setFreeTrialOrderNumberWPS,
	freeTrialPrevStepWPS,
} from "./slices/freeTrialSliceWPS";

import {
  acgtCardReducer,
  setCardPage,
  setPurchaseCardAmount,
  setPurchaseSelectedCard,
  clearAmount,
  setPurchaseCardOtherAmount,
  setPurchaseCardQuantity,
  resetCardPage,
  setCardNumber,
  setPinNumber,
  resetActivation,
  setUserAcgtCards,
  setPurchasePrevStep,
  setPurchaseNextStep,
  resetAcgtCard,
} from "./slices/acgtCardSlice";

import {
  sppeFormReducer,
  setSppeShippingOption,
  setSppePoNumber,
  setSppeGrantNumber,
  setSppeGrantPI,
  setSppeGrantNote,
  setSppeOrderNumber,
  setSppeOrderAmount,
  setSppeOrderDiscount,
  setSppeCardType,
  setSppeCCName,
  setSppePurchasingAgentEmail,
  setSppePurchasingAgentName,
  setSppeCCNumber,
  setSppeCCMonth,
  setSppeCCYear,
  setSppeCVV,
  setSppeCCZip,
  setSppeBillingMethod,
  resetSppeTableData,
  setSppeAcgtCard,
  setSppeEmail,
  setSppeCompany,
  setSppePhone,
  setSppeFirstName,
  setSppeLastName,
  setSppeDropoffDate,
  increaseSppeConcentration,
  decreaseSppeConcentration,
  initializeSppeTableData,
  setSppeServiceOption,
  setSppeServicePriority,
  setSppeSampleAmount,
  addSppeRow,
  resetSppeState,
  editSppeRow,
  deleteSppeRow,
  copySppeRow,
  toggleSppeCheckbox,
  sppePrevStep,
  sppeNextStep,
  sppeSetStep,
  resetSppePage,
  editSppePrimerRow,
  addSppePrimerRow,
  setSppePrimerAmount,
  initializeSppePrimerTableData,
  resetSppePrimerTableData,
  deleteAllSppePrimer,
  setSppeConsensusSequence,
  setSppePrimerBanking,
  setSppePrimerList,
  setSppePrimerSynthesis,
  setSppePrimerComments,
  clearSppeSelect,
  clearSppeServiceOption,
  setSppeDropboxLocation,
  setSppeDropboxId,
  setSelectedWpsOrderNumber,
} from "./slices/sppeFormSlice";

import {
  dcssFormReducer,
  initializeDcssTableData,
  resetDcssState,
  resetDcssTableData,
  setDcssSampleAmount,
  addDcssRow,
  editDcssRow,
  copyDcssRow,
  deleteDcssRow,
  toggleDcssCheckbox,
  increaseDcssConcentration,
  decreaseDcssConcentration,
  clearDcssSelect,
  dcssNextStep,
  dcssPrevStep,
  dcssSetStep,
  resetDcssPage,
  initializeDcssPrimerTableData,
  resetDcssPrimerTableData,
  setDcssPrimerAmount,
  addDcssPrimerRow,
  editDcssPrimerRow,
  deleteAllDcssPrimer,
  setDcssPrimerBanking,
  setDcssPrimerList,
  setDcssPrimerSynthesis,
  setDcssPrimerComments,
  setDcssDropoffDate,
  setDcssDropboxLocation,
  setDcssDropboxId,
  setDcssFirstName,
  setDcssLastName,
  setDcssCompany,
  setDcssPhone,
  setDcssEmail,
  setDcssShippingOption,
  setDcssAcgtCard,
  setDcssCCNumber,
  setDcssCCMonth,
  setDcssCCYear,
  setDcssCVV,
  setDcssCCZip,
  setDcssCCName,
  setDcssCardType,
  setDcssPurchasingAgentName,
  setDcssPurchasingAgentEmail,
  setDcssPoNumber,
  setDcssGrantNumber,
  setDcssGrantPI,
  setDcssGrantNote,
  setDcssOrderNumber,
	setDcssOrderAmount,
	setDcssOrderDiscount,
  setDcssBillingMethod,
} from "./slices/dcssFormSlice";

import {
  fsaFormReducer,
  initializeFsaTableData,
  resetFsaState,
  resetFsaTableData,
  setFsaSampleAmount,
  addFsaRow,
  editFsaRow,
  copyFsaRow,
  deleteFsaRow,
  toggleFsaCheckbox,
  increaseFsaConcentration,
  decreaseFsaConcentration,
  clearFsaSelect,
  fsaNextStep,
  fsaPrevStep,
  fsaSetStep,
  resetFsaPage,
  initializeFsaPrimerTableData,
  resetFsaPrimerTableData,
  setFsaPrimerAmount,
  addFsaPrimerRow,
  editFsaPrimerRow,
  deleteAllFsaPrimer,
  setFsaPrimerBanking,
  setFsaPrimerList,
  setFsaPrimerSynthesis,
  setFsaPrimerComments,
  setFsaDropoffDate,
  setFsaDropboxId,
  setFsaDropboxLocation,
  setFsaFirstName,
  setFsaLastName,
  setFsaCompany,
  setFsaPhone,
  setFsaEmail,
  setFsaShippingOption,
  setFsaAcgtCard,
  setFsaCCNumber,
  setFsaCCMonth,
  setFsaCCYear,
  setFsaCVV,
  setFsaCCZip,
  setFsaCCName,
  setFsaCardType,
  setFsaPurchasingAgentName,
  setFsaPurchasingAgentEmail,
  setFsaPoNumber,
  setFsaEstimate,
  setFsaGrantNote,
  setFsaGrantNumber,
  setFsaOrderNumber,
  setFsaOrderAmount,
  setFsaGrantPI,
  setFsaBillingMethod,
} from "./slices/fsaFormSlice";

import {
  htpFormReducer,
  setPlateAmount,
  initializeHtpTableData,
  addHtpPlate,
  resetHtpState,
  resetHtpTableData,
  setHtpServiceOption,
  setHtpOrderOption,
  setSelectedPlate,
  setHtpOrderNumber,
	setHtpOrderAmount,
	setHtpOrderDiscount,
  deleteHtpPlate,
  editHtpRow,
  handleLeftArrow,
  handleRightArrow,
  toggleHtpCheckbox,
  increaseHtpConcentration,
  decreaseHtpConcentration,
  clearHtpSelect,
  htpNextStep,
  htpPrevStep,
  htpSetStep,
  resetHtpPage,
  initializeHtpPrimerTableData,
  resetHtpPrimerTableData,
  setHtpPrimerAmount,
  addHtpPrimerRow,
  editHtpPrimerRow,
  deleteAllHtpPrimer,
  setHtpPrimerBanking,
  setHtpPrimerList,
  setHtpPrimerSynthesis,
  setHtpPrimerComments,
  setHtpDropoffDate,
  setHtpDropboxLocation,
  setHtpDropboxId,
  setHtpFirstName,
  setHtpLastName,
  setHtpCompany,
  setHtpPhone,
  setHtpEmail,
  setHtpShippingOption,
  setHtpAcgtCard,
  setHtpCCNumber,
  setHtpCCMonth,
  setHtpCCYear,
  setHtpCVV,
  setHtpCCZip,
  setHtpCCName,
  setHtpCardType,
  setHtpPurchasingAgentName,
  setHtpPurchasingAgentEmail,
  setHtpPoNumber,
  setHtpGrantNumber,
  setHtpGrantPI,
  setHtpGrantNote,
  setHtpBillingMethod,
  clearHtpServiceOption,
  clearHtpOrderOption,
  setHtpAlt,
  setHtpDnaType,
  setHtpPcrSize,
  setHtpPrimerConc,
  setHtpTemplateConc,
  setHtpPlateName,
} from "./slices/htpFormSlice";

import {
	fragFormReducer,
	initializeFragTableData,
	addFragPlate,
	setFragOrderOption,
	clearFragOrderOption,
	setFragServiceOption,
	clearFragServiceOption,
	setFragSelectedPlate,
	setFragOrderNumber,
	setFragOrderAmount,
	setFragOrderDiscount,
	deleteFragPlate,
	setFragPlateAmount,
	setFragAlt,
	setFragDnaType,
	setFragPcrSize,
	setFragPrimerConc,
	setFragTemplateConc,
	setFragPlateName,
	resetFragState,
	resetFragTableData,
	editFragRow,
	toggleCheckbox,
	handleFragLeftArrow,
	handleFragRightArrow,
	toggleFragCheckbox,
	increaseFragConcentration,
	decreaseFragConcentration,
	clearFragSelect,
	fragNextStep,
	fragPrevStep,
	fragSetStep,
	resetFragPage,
	initializeFragPrimerTableData,
	resetFragPrimerTableData,
	setFragPrimerAmount,
	addFragPrimerRow,
	editFragPrimerRow,
	deleteAllFragPrimer,
	setFragPrimerBanking,
	setFragPrimerList,
	setFragPrimerSynthesis,
	setFragPrimerComments,
	setFragDropoffDate,
	setFragDropboxLocation,
	setFragDropboxId,
	setFragFirstName,
	setFragLastName,
	setFragCompany,
	setFragPhone,
	setFragEmail,
	setFragShippingOption,
	setFragAcgtCard,
	setFragCCNumber,
	setFragCCMonth,
	setFragCCYear,
	setFragCVV,
	setFragCCZip,
	setFragCCName,
	setFragCardType,
	setFragPurchasingAgentName,
	setFragPurchasingAgentEmail,
	setFragPoNumber,
	setFragGrantNumber,
	setFragGrantPI,
	setFragGrantNote,
	setFragBillingMethod,
	setFragStaging,
	setFragAnalysis,
} from "./slices/fragFormSlice";

import {
  ngsFormReducer,
  initializeNgsTableData,
  resetNgsState,
  resetNgsTableData,
  setNgsSampleAmount,
  addNgsRow,
  editNgsRow,
  copyNgsRow,
  deleteNgsRow,
  toggleNgsCheckbox,
  increaseNgsConcentration,
  decreaseNgsConcentration,
  clearNgsSelect,
  ngsNextStep,
  ngsPrevStep,
  ngsSetStep,
  resetNgsPage,
  initializeNgsPrimerTableData,
  setNgsPrimerAmount,
  addNgsPrimerRow,
  editNgsPrimerRow,
  deleteAllNgsPrimer,
  setNgsPrimerBanking,
  setNgsPrimerList,
  setNgsPrimerSynthesis,
  setNgsComments,
  setNgsDropoffDate,
  setNgsDropboxLocation,
  setNgsDropboxId,
  setNgsFirstName,
  setNgsLastName,
  setNgsCompany,
  setNgsPhone,
  setNgsEmail,
  setNgsShippingOption,
  setNgsAcgtCard,
  setNgsCCNumber,
  setNgsCCMonth,
  setNgsCCYear,
  setNgsCVV,
  setNgsCCZip,
  setNgsCCName,
  setNgsCardType,
  setNgsPurchasingAgentName,
  setNgsPurchasingAgentEmail,
  setNgsPoNumber,
  setNgsOrderNumber,
  setNgsOrderAmount,
  setNgsGrantNumber,
  setNgsGrantPI,
  setNgsGrantNote,
  setNgsBillingMethod,
} from "./slices/ngsFormSlice";

import {
  wpsFormReducer,
  initializeWpsTableData,
  resetWpsState,
  resetWpsTableData,
  setWpsSampleAmount,
  addWpsRow,
  editWpsRow,
  copyWpsRow,
  deleteWpsRow,
  toggleWpsCheckbox,
  increaseWpsConcentration,
  decreaseWpsConcentration,
  clearWpsSelect,
  wpsNextStep,
  wpsPrevStep,
  wpsSetStep,
  resetWpsPage,
  initializeWpsPrimerTableData,
  setWpsPrimerAmount,
  addWpsPrimerRow,
  editWpsPrimerRow,
  deleteAllWpsPrimer,
  setWpsPrimerBanking,
  setWpsPrimerList,
  setWpsPrimerSynthesis,
  setWpsComments,
  setWpsDropoffDate,
  setWpsDropboxLocation,
  setWpsDropboxId,
  setWpsFirstName,
  setWpsLastName,
  setWpsCompany,
  setWpsPhone,
  setWpsEmail,
  setWpsShippingOption,
  setWpsAcgtCard,
  setWpsCCNumber,
  setWpsCCMonth,
  setWpsCCYear,
  setWpsCVV,
  setWpsCCZip,
  setWpsCCName,
  setWpsCardType,
  setWpsPurchasingAgentName,
  setWpsPurchasingAgentEmail,
  setWpsPoNumber,
  setWpsOrderNumber,
  setWpsOrderAmount,
  setWpsOrderAmountWithDiscount,
  setWpsOrderDiscount,
  setWpsGrantNumber,
  setWpsGrantPI,
  setWpsGrantNote,
	setWpsBillingMethod,
	setWpsServiceOption,
	clearWpsServiceOption,
} from "./slices/wpsFormSlice";

import {
  primerFormReducer,
  resetPrimerState,
  primerNextStep,
  primerPrevStep,
  primerSetStep,
  resetPrimerPage,
  initializePrimerTableData,
  resetPrimerTableData,
  setPrimerAmount,
  addPrimerRow,
  editPrimerRow,
  deleteAllPrimer,
  setPrimerBanking,
  setPrimerList,
  setPrimerSynthesis,
  setPrimerComments,
  setPrimerDropoffDate,
  setPrimerDropboxLocation,
  setPrimerFirstName,
  setPrimerLastName,
  setPrimerCompany,
  setPrimerPhone,
  setPrimerEmail,
  setPrimerShippingOption,
  setPrimerAcgtCard,
  setPrimerCCNumber,
  setPrimerCCMonth,
  setPrimerCCYear,
  setPrimerCVV,
  setPrimerCCZip,
  setPrimerCCName,
  setPrimerCardType,
  setPrimerPurchasingAgentName,
  setPrimerPurchasingAgentEmail,
  setPrimerPoNumber,
  setPrimerGrantNumber,
  setPrimerGrantPI,
  setPrimerGrantNote,
  setPrimerOrderNumber,
  setPrimerOrderAmount,
  setPrimerBillingMethod,
} from "./slices/primerFormSlice";

import {
  contractFormReducer,
  resetContractState,
  contractNextStep,
  contractPrevStep,
  contractSetStep,
  resetContractPage,
  setContractQuoteNumber,
  setContractDescription,
  setContractComments,
  setContractDropoffDate,
  setContractDropboxLocation,
  setContractFirstName,
  setContractLastName,
  setContractCompany,
  setContractPhone,
  setContractEmail,
  setContractShippingOption,
  setContractAcgtCard,
  setContractCCNumber,
  setContractCCMonth,
  setContractCCYear,
  setContractCVV,
  setContractCCName,
  setContractCardType,
  setContractPurchasingAgentName,
  setContractPurchasingAgentEmail,
  setContractPoNumber,
  setContractOrderNumber,
  setContractGrantNote,
  setContractGrantNumber,
  setContractGrantPI,
  setContractBillingMethod,
} from "./slices/contractFormSlice";

import {
  resetQuoteRequestState,
  quoteRequestNextStep,
  quoteRequestPrevStep,
  quoteRequestSetStep,
  resetQuoteRequestPage,
  setQuoteRequestServiceInterest,
  setQuoteRequestServiceLevel,
  setQuoteRequestDescription,
  setQuoteRequestComments,
  setQuoteRequestDropoffDate,
  setQuoteRequestDropboxLocation,
  setQuoteRequestFirstName,
  setQuoteRequestLastName,
  setQuoteRequestJobtitle,
  setQuoteRequestPI,
  setQuoteRequestChannel,
  setQuoteRequestAddress,
  setQuoteRequestCity,
  setQuoteRequestState,
  setQuoteRequestZip,
  setQuoteRequestCompany,
  setQuoteRequestPhone,
  setQuoteRequestEmail,
  setQuoteRequestShippingOption,
  setQuoteRequestAcgtCard,
  setQuoteRequestCCNumber,
  setQuoteRequestCCMonth,
  setQuoteRequestCCYear,
  setQuoteRequestCVV,
  setQuoteRequestCCName,
  setQuoteRequestCardType,
  setQuoteRequestPurchasingAgentName,
  setQuoteRequestPurchasingAgentEmail,
  setQuoteRequestPoNumber,
  setQuoteRequestBillingMethod,
} from "./slices/quoteRequestSlice";

import {
  genomicFormReducer,
  initializeGenomicSampleData,
  genomicPrevStep,
  clearGenomicSelect,
  clearGenomicSelectAmplicon,
  genomicNextStep,
  genomicSetStep,
  resetGenomicPage,
  resetGenomicState,
  resetGenomicSampleData,
  resetGenomicAmpliconData,
  setGenomicSampleAmount,
  addGenomicSample,
  deleteGenomicSample,
  setGenomicTemplateName,
  setGenomicAmpliconAmount,
  setGenomicGelPurification,
  setGenomicConsensus,
  initializeGenomicAmplicon,
  addGenomicAmplicon,
  editGenomicAmplicon,
  deleteGenomicAmplicon,
  setGenomicDropoffDate,
  setGenomicDropboxLocation,
  setGenomicDropboxId,
  setGenomicFirstName,
  setGenomicLastName,
  setGenomicCompany,
  setGenomicPhone,
  setGenomicEmail,
  setGenomicShippingOption,
  setGenomicAcgtCard,
  setGenomicCCNumber,
  setGenomicCCMonth,
  setGenomicCCYear,
  setGenomicCVV,
  setGenomicCCZip,
  setGenomicCCName,
  setGenomicCardType,
  setGenomicPurchasingAgentName,
  setGenomicPurchasingAgentEmail,
  setGenomicPoNumber,
  setGenomicOrderNumber,
  setGenomicOrderAmount,
  setGenomicGrantNumber,
  setGenomicGrantPI,
  setGenomicGrantNote,
  setGenomicBillingMethod,
} from "./slices/genomicFormSlice";

import {
  profileReducer,
  setPage,
  setProfileUserData,
  setProfilePurchasingAgent,
  resetProfile,
  editPersonalInformation,
  editPurchasingAgentInformation,
} from "./slices/profileSlice";

import { reset } from "./actions";

import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";
import { quoteRequestReducer } from "./slices/quoteRequestSlice";

// wpsDqc
import { 
  wpsDqcReducer,
  initializeWpsDqc,

  resetWpsDqcState,
  resetWpsDqcPage,
  editWpsDqcRow,
  editWpsDqcSangerRow,
  increaseWpsDqcConcentration,
  decreaseWpsDqcConcentration,
  editWpsDqcComments,
  clearWpsDqcSelect,
  wpsDqcNextStep,
  setWpsDqcOrderNumber,
  wpsDqcPrevStep,
  setWpsDqcSangerOption,
  toggleWpsDqcCheckbox
 } from "./slices/wpsDqcFormSlice";


const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const reducer = combineReducers({
  user: userReducer,
  userAdmin: userAdminReducer,
  sppeForm: sppeFormReducer,
  dcssForm: dcssFormReducer,
  fsaForm: fsaFormReducer,
	htpForm: htpFormReducer,
	fragForm: fragFormReducer,
  ngsForm: ngsFormReducer,
  primerForm: primerFormReducer,
  profile: profileReducer,
  acgtcard: acgtCardReducer,
  contractForm: contractFormReducer,
  quoteRequestForm: quoteRequestReducer,
  genomicForm: genomicFormReducer,
	freeTrialForm: freeTrialReducer,
	freeTrialFormWPS: freeTrialReducerWPS,
	wpsForm: wpsFormReducer,
	wpsDqcForm: wpsDqcReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

//holds all the reducers from slices
const store = configureStore({
  reducer: persistedReducer,
});

// Redux exports
export { store, reset };

// User exports
export { setUser, isLoggedIn, logout, setDropboxLocations, setPaymentType, setUserPrices, setUserPrimers, setWpsExcludeCorp };

// Admin exports
export {setUserAdmin, isAdminLoggedIn, logoutAdmin};

// Free Trial exports
export {
  initializeFreeTrialData,
  setFreeTrialSampleAmount,
  setFreeTrialServiceOption,
  setFreeTrialServicePriority,
  editFreeTrialRow,
  increaseFreeTrialConcentration,
  decreaseFreeTrialConcentration,
  editFreeTrialComments,
  clearFreeTrialSelect,
  resetFreeTrialState,
  setFreeTrialOrderNumber,
  resetFreeTrialPage,
  freeTrialNextStep,
  freeTrialPrevStep,
};

// Free Trial WPS exports
export {
	initializeFreeTrialDataWPS,
	setFreeTrialSampleAmountWPS,
	editFreeTrialRowWPS,
	increaseFreeTrialConcentrationWPS,
	decreaseFreeTrialConcentrationWPS,
	editFreeTrialCommentsWPS,
	clearFreeTrialSelectWPS,
	resetFreeTrialStateWPS,
	setFreeTrialOrderNumberWPS,
	resetFreeTrialPageWPS,
	freeTrialNextStepWPS,
	freeTrialPrevStepWPS,
};

// acgtCard exports
export {
  setCardPage,
  setPurchaseCardAmount,
  setPurchaseSelectedCard,
  clearAmount,
  setPurchaseCardOtherAmount,
  setPurchaseCardQuantity,
  resetCardPage,
  setCardNumber,
  setPinNumber,
  resetActivation,
  setUserAcgtCards,
  setPurchasePrevStep,
  setPurchaseNextStep,
  resetAcgtCard,
};

// SPPE exports
export {
  setSppeShippingOption,
  setSppePoNumber,
  setSppeGrantNumber,
  setSppeGrantPI,
  setSppeGrantNote,
  setSppeOrderNumber,
  setSppeOrderAmount,
  setSppeOrderDiscount,
  setSppeCardType,
  setSppeCCName,
  setSppePurchasingAgentEmail,
  setSppePurchasingAgentName,
  setSppeCCNumber,
  setSppeCCMonth,
  setSppeCCYear,
  setSppeCVV,
  setSppeCCZip,
  setSppeBillingMethod,
  resetSppeTableData,
  setSppeAcgtCard,
  setSppeEmail,
  setSppeCompany,
  setSppePhone,
  setSppeFirstName,
  setSppeLastName,
  setSppeDropoffDate,
  increaseSppeConcentration,
  decreaseSppeConcentration,
  initializeSppeTableData,
  setSppeServiceOption,
  setSppeServicePriority,
  setSppeSampleAmount,
  addSppeRow,
  resetSppeState,
  editSppeRow,
  deleteSppeRow,
  copySppeRow,
  toggleSppeCheckbox,
  sppePrevStep,
  sppeNextStep,
  sppeSetStep,
  resetSppePage,
  editSppePrimerRow,
  addSppePrimerRow,
  setSppePrimerAmount,
  initializeSppePrimerTableData,
  resetSppePrimerTableData,
  deleteAllSppePrimer,
  setSppeConsensusSequence,
  setSppePrimerBanking,
  setSppePrimerList,
  setSppePrimerSynthesis,
  setSppePrimerComments,
  clearSppeSelect,
  clearSppeServiceOption,
  setSppeDropboxLocation,
  setSppeDropboxId,
  setSelectedWpsOrderNumber,
};

// DCSS exports
export {
  initializeDcssTableData,
  resetDcssState,
  resetDcssTableData,
  setDcssSampleAmount,
  addDcssRow,
  editDcssRow,
  copyDcssRow,
  deleteDcssRow,
  toggleDcssCheckbox,
  increaseDcssConcentration,
  decreaseDcssConcentration,
  clearDcssSelect,
  dcssNextStep,
  dcssPrevStep,
  dcssSetStep,
  resetDcssPage,
  initializeDcssPrimerTableData,
  resetDcssPrimerTableData,
  setDcssPrimerAmount,
  addDcssPrimerRow,
  editDcssPrimerRow,
  deleteAllDcssPrimer,
  setDcssPrimerBanking,
  setDcssPrimerList,
  setDcssPrimerSynthesis,
  setDcssPrimerComments,
  setDcssDropoffDate,
  setDcssDropboxLocation,
  setDcssDropboxId,
  setDcssFirstName,
  setDcssLastName,
  setDcssCompany,
  setDcssPhone,
  setDcssEmail,
  setDcssShippingOption,
  setDcssAcgtCard,
  setDcssCCNumber,
  setDcssCCMonth,
  setDcssCCYear,
  setDcssCVV,
  setDcssCCZip,
  setDcssCCName,
  setDcssCardType,
  setDcssPurchasingAgentName,
  setDcssPurchasingAgentEmail,
  setDcssPoNumber,
  setDcssGrantNumber,
  setDcssGrantPI,
  setDcssGrantNote,
  setDcssOrderNumber,
	setDcssOrderAmount,
	setDcssOrderDiscount,
  setDcssBillingMethod,
};

// FSA exports
export {
  initializeFsaTableData,
  resetFsaState,
  resetFsaTableData,
  setFsaSampleAmount,
  addFsaRow,
  editFsaRow,
  copyFsaRow,
  deleteFsaRow,
  toggleFsaCheckbox,
  increaseFsaConcentration,
  decreaseFsaConcentration,
  clearFsaSelect,
  fsaNextStep,
  fsaPrevStep,
  fsaSetStep,
  resetFsaPage,
  initializeFsaPrimerTableData,
  resetFsaPrimerTableData,
  setFsaPrimerAmount,
  addFsaPrimerRow,
  editFsaPrimerRow,
  deleteAllFsaPrimer,
  setFsaPrimerBanking,
  setFsaPrimerList,
  setFsaPrimerSynthesis,
  setFsaPrimerComments,
  setFsaDropoffDate,
  setFsaDropboxLocation,
  setFsaDropboxId,
  setFsaFirstName,
  setFsaLastName,
  setFsaCompany,
  setFsaPhone,
  setFsaEmail,
  setFsaShippingOption,
  setFsaAcgtCard,
  setFsaCCNumber,
  setFsaCCMonth,
  setFsaCCYear,
  setFsaCVV,
  setFsaCCZip,
  setFsaCCName,
  setFsaCardType,
  setFsaPurchasingAgentName,
  setFsaPurchasingAgentEmail,
  setFsaPoNumber,
  setFsaEstimate,
  setFsaGrantNote,
  setFsaOrderNumber,
  setFsaOrderAmount,
  setFsaGrantNumber,
  setFsaGrantPI,
  setFsaBillingMethod,
};

// HTP exports
export {
  setPlateAmount,
  initializeHtpTableData,
  addHtpPlate,
  resetHtpState,
  resetHtpTableData,
  setHtpServiceOption,
  setHtpOrderOption,
  setSelectedPlate,
  setHtpOrderNumber,
	setHtpOrderAmount,
	setHtpOrderDiscount,
  deleteHtpPlate,
  editHtpRow,
  handleLeftArrow,
  handleRightArrow,
  toggleHtpCheckbox,
  increaseHtpConcentration,
  decreaseHtpConcentration,
  clearHtpSelect,
  htpNextStep,
  htpPrevStep,
  htpSetStep,
  resetHtpPage,
  initializeHtpPrimerTableData,
  resetHtpPrimerTableData,
  setHtpPrimerAmount,
  addHtpPrimerRow,
  editHtpPrimerRow,
  deleteAllHtpPrimer,
  setHtpPrimerBanking,
  setHtpPrimerList,
  setHtpPrimerSynthesis,
  setHtpPrimerComments,
  setHtpDropoffDate,
  setHtpDropboxLocation,
  setHtpDropboxId,
  setHtpFirstName,
  setHtpLastName,
  setHtpCompany,
  setHtpPhone,
  setHtpEmail,
  setHtpShippingOption,
  setHtpAcgtCard,
  setHtpCCNumber,
  setHtpCCMonth,
  setHtpCCYear,
  setHtpCVV,
  setHtpCCZip,
  setHtpCCName,
  setHtpCardType,
  setHtpPurchasingAgentName,
  setHtpPurchasingAgentEmail,
  setHtpPoNumber,
  setHtpGrantNumber,
  setHtpGrantPI,
  setHtpGrantNote,
  setHtpBillingMethod,
  clearHtpServiceOption,
  clearHtpOrderOption,
  setHtpAlt,
  setHtpDnaType,
  setHtpPcrSize,
  setHtpPrimerConc,
  setHtpTemplateConc,
  setHtpPlateName
};

// Frag exports
export {
	initializeFragTableData,
	addFragPlate,
	setFragOrderOption,
	clearFragOrderOption,
	setFragServiceOption,
	clearFragServiceOption,
	setFragSelectedPlate,
	setFragOrderNumber,
	setFragOrderAmount,
	setFragOrderDiscount,
	deleteFragPlate,
	setFragPlateAmount,
	setFragAlt,
	setFragDnaType,
	setFragPcrSize,
	setFragPrimerConc,
	setFragTemplateConc,
	setFragPlateName,
	resetFragState,
	resetFragTableData,
	editFragRow,
	toggleCheckbox,
	handleFragLeftArrow,
	handleFragRightArrow,
	toggleFragCheckbox,
	increaseFragConcentration,
	decreaseFragConcentration,
	clearFragSelect,
	fragNextStep,
	fragPrevStep,
	fragSetStep,
	resetFragPage,
	initializeFragPrimerTableData,
	resetFragPrimerTableData,
	setFragPrimerAmount,
	addFragPrimerRow,
	editFragPrimerRow,
	deleteAllFragPrimer,
	setFragPrimerBanking,
	setFragPrimerList,
	setFragPrimerSynthesis,
	setFragPrimerComments,
	setFragDropoffDate,
	setFragDropboxLocation,
	setFragDropboxId,
	setFragFirstName,
	setFragLastName,
	setFragCompany,
	setFragPhone,
	setFragEmail,
	setFragShippingOption,
	setFragAcgtCard,
	setFragCCNumber,
	setFragCCMonth,
	setFragCCYear,
	setFragCVV,
	setFragCCZip,
	setFragCCName,
	setFragCardType,
	setFragPurchasingAgentName,
	setFragPurchasingAgentEmail,
	setFragPoNumber,
	setFragGrantNumber,
	setFragGrantPI,
	setFragGrantNote,
	setFragBillingMethod,
	setFragStaging,
	setFragAnalysis,
};

// NGS exports
export {
  initializeNgsTableData,
  resetNgsState,
  resetNgsTableData,
  setNgsSampleAmount,
  addNgsRow,
  editNgsRow,
  copyNgsRow,
  deleteNgsRow,
  toggleNgsCheckbox,
  increaseNgsConcentration,
  decreaseNgsConcentration,
  clearNgsSelect,
  ngsNextStep,
  ngsPrevStep,
  ngsSetStep,
  resetNgsPage,
  initializeNgsPrimerTableData,
  setNgsPrimerAmount,
  addNgsPrimerRow,
  editNgsPrimerRow,
  deleteAllNgsPrimer,
  setNgsPrimerBanking,
  setNgsPrimerList,
  setNgsPrimerSynthesis,
  setNgsComments,
  setNgsDropoffDate,
  setNgsDropboxLocation,
  setNgsDropboxId,
  setNgsFirstName,
  setNgsLastName,
  setNgsCompany,
  setNgsPhone,
  setNgsEmail,
  setNgsShippingOption,
  setNgsAcgtCard,
  setNgsCCNumber,
  setNgsCCMonth,
  setNgsCCYear,
  setNgsCVV,
  setNgsCCZip,
  setNgsCCName,
  setNgsCardType,
  setNgsPurchasingAgentName,
  setNgsPurchasingAgentEmail,
  setNgsPoNumber,
  setNgsOrderNumber,
  setNgsOrderAmount,
  setNgsGrantNumber,
  setNgsGrantPI,
  setNgsGrantNote,
  setNgsBillingMethod,
};

// WPS exports
export {
  initializeWpsTableData,
  resetWpsState,
  resetWpsTableData,
  setWpsSampleAmount,
  addWpsRow,
  editWpsRow,
  copyWpsRow,
  deleteWpsRow,
  toggleWpsCheckbox,
  increaseWpsConcentration,
  decreaseWpsConcentration,
  clearWpsSelect,
  wpsNextStep,
  wpsPrevStep,
  wpsSetStep,
  resetWpsPage,
  initializeWpsPrimerTableData,
  setWpsPrimerAmount,
  addWpsPrimerRow,
  editWpsPrimerRow,
  deleteAllWpsPrimer,
  setWpsPrimerBanking,
  setWpsPrimerList,
  setWpsPrimerSynthesis,
  setWpsComments,
  setWpsDropoffDate,
  setWpsDropboxLocation,
  setWpsDropboxId,
  setWpsFirstName,
  setWpsLastName,
  setWpsCompany,
  setWpsPhone,
  setWpsEmail,
  setWpsShippingOption,
  setWpsAcgtCard,
  setWpsCCNumber,
  setWpsCCMonth,
  setWpsCCYear,
  setWpsCVV,
  setWpsCCZip,
  setWpsCCName,
  setWpsCardType,
  setWpsPurchasingAgentName,
  setWpsPurchasingAgentEmail,
  setWpsPoNumber,
  setWpsOrderNumber,
  setWpsOrderAmount,
  setWpsOrderAmountWithDiscount,
  setWpsOrderDiscount,
  setWpsGrantNumber,
  setWpsGrantPI,
  setWpsGrantNote,
	setWpsBillingMethod,
	setWpsServiceOption,
	clearWpsServiceOption,
};

// Primer Exports
export {
  resetPrimerState,
  primerNextStep,
  primerPrevStep,
  primerSetStep,
  resetPrimerPage,
  initializePrimerTableData,
  resetPrimerTableData,
  setPrimerAmount,
  addPrimerRow,
  editPrimerRow,
  deleteAllPrimer,
  setPrimerBanking,
  setPrimerList,
  setPrimerSynthesis,
  setPrimerComments,
  setPrimerDropoffDate,
  setPrimerDropboxLocation,
  setPrimerFirstName,
  setPrimerLastName,
  setPrimerCompany,
  setPrimerPhone,
  setPrimerEmail,
  setPrimerShippingOption,
  setPrimerAcgtCard,
  setPrimerCCNumber,
  setPrimerCCMonth,
  setPrimerCCYear,
  setPrimerCVV,
  setPrimerCCZip,
  setPrimerCCName,
  setPrimerCardType,
  setPrimerPurchasingAgentName,
  setPrimerPurchasingAgentEmail,
  setPrimerPoNumber,
  setPrimerGrantNumber,
  setPrimerGrantPI,
  setPrimerGrantNote,
  setPrimerOrderNumber,
  setPrimerOrderAmount,
  setPrimerBillingMethod,
};

// Contract Exports
export {
  resetContractState,
  contractNextStep,
  contractPrevStep,
  contractSetStep,
  resetContractPage,
  setContractQuoteNumber,
  setContractDescription,
  setContractComments,
  setContractDropoffDate,
  setContractDropboxLocation,
  setContractFirstName,
  setContractLastName,
  setContractCompany,
  setContractPhone,
  setContractEmail,
  setContractShippingOption,
  setContractAcgtCard,
  setContractCCNumber,
  setContractCCMonth,
  setContractCCYear,
  setContractCVV,
  setContractCCName,
  setContractCardType,
  setContractPurchasingAgentName,
  setContractPurchasingAgentEmail,
  setContractPoNumber,
  setContractOrderNumber,
  setContractGrantNote,
  setContractGrantNumber,
  setContractGrantPI,
  setContractBillingMethod,
};

// Quote Request Exports
export {
  resetQuoteRequestState,
  quoteRequestNextStep,
  quoteRequestPrevStep,
  quoteRequestSetStep,
  resetQuoteRequestPage,
  setQuoteRequestServiceInterest,
  setQuoteRequestServiceLevel,
  setQuoteRequestDescription,
  setQuoteRequestComments,
  setQuoteRequestDropoffDate,
  setQuoteRequestDropboxLocation,
  setQuoteRequestFirstName,
  setQuoteRequestLastName,
  setQuoteRequestJobtitle,
  setQuoteRequestPI,
  setQuoteRequestChannel,
  setQuoteRequestAddress,
  setQuoteRequestCity,
  setQuoteRequestState,
  setQuoteRequestZip,
  setQuoteRequestCompany,
  setQuoteRequestPhone,
  setQuoteRequestEmail,
  setQuoteRequestShippingOption,
  setQuoteRequestAcgtCard,
  setQuoteRequestCCNumber,
  setQuoteRequestCCMonth,
  setQuoteRequestCCYear,
  setQuoteRequestCVV,
  setQuoteRequestCCName,
  setQuoteRequestCardType,
  setQuoteRequestPurchasingAgentName,
  setQuoteRequestPurchasingAgentEmail,
  setQuoteRequestPoNumber,
  setQuoteRequestBillingMethod,
};

// Genomic Exports
export {
  initializeGenomicSampleData,
  genomicPrevStep,
  clearGenomicSelect,
  clearGenomicSelectAmplicon,
  genomicNextStep,
  genomicSetStep,
  resetGenomicPage,
  resetGenomicState,
  resetGenomicSampleData,
  resetGenomicAmpliconData,
  setGenomicSampleAmount,
  addGenomicSample,
  deleteGenomicSample,
  setGenomicTemplateName,
  setGenomicAmpliconAmount,
  setGenomicGelPurification,
  setGenomicConsensus,
  initializeGenomicAmplicon,
  addGenomicAmplicon,
  editGenomicAmplicon,
  deleteGenomicAmplicon,
  setGenomicDropoffDate,
  setGenomicDropboxLocation,
  setGenomicDropboxId,
  setGenomicFirstName,
  setGenomicLastName,
  setGenomicCompany,
  setGenomicPhone,
  setGenomicEmail,
  setGenomicShippingOption,
  setGenomicAcgtCard,
  setGenomicCCNumber,
  setGenomicCCMonth,
  setGenomicCCYear,
  setGenomicCVV,
  setGenomicCCZip,
  setGenomicCCName,
  setGenomicCardType,
  setGenomicPurchasingAgentName,
  setGenomicPurchasingAgentEmail,
  setGenomicPoNumber,
  setGenomicOrderNumber,
  setGenomicOrderAmount,
  setGenomicGrantNumber,
  setGenomicGrantPI,
  setGenomicGrantNote,
  setGenomicBillingMethod,
};

// Profile Exports
export {
  setPage,
  setProfileUserData,
  setProfilePurchasingAgent,
  resetProfile,
  editPersonalInformation,
  editPurchasingAgentInformation,
};


// WPSDQC
export {
  initializeWpsDqc,
  resetWpsDqcState,
  resetWpsDqcPage,
  editWpsDqcRow,
  editWpsDqcSangerRow,
  increaseWpsDqcConcentration,
  decreaseWpsDqcConcentration,
  editWpsDqcComments,
  clearWpsDqcSelect,
  wpsDqcNextStep,
  setWpsDqcOrderNumber,
  wpsDqcPrevStep,
  setWpsDqcSangerOption,
  toggleWpsDqcCheckbox,
}